import {Link, useNavigate} from 'react-router-dom';
import { To } from 'history';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';
import { SxProps } from '@mui/system';

// project-imports
import Logo from './LogoMain';
import LogoIcon from './LogoIcon';

interface Props {
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection({ isIcon, sx, to }: Props) {
  const { isLoggedIn } = {isLoggedIn: null};
  const navigate = useNavigate();

  return (
    <ButtonBase
        onClick={() => navigate("/")}>
      {isIcon ? <LogoIcon /> : <Logo />}
    </ButtonBase>
  );
}
